import { BaseNimbleAPI } from './baseAPI';
import { EmailTemplate } from 'components/CandidatesList/MarketplaceProspectQuickView/types';

class EmailTemplatesAPI extends BaseNimbleAPI {
  get config() {
    return { baseURL: '/api/emailtemplates' };
  }

  async getTemplatesForReferences(): Promise<EmailTemplate[]> {
    const url = '/?reference=true';
    const response = await this.get(url);
    return response.data;
  }

  async getEmailTemplatesForAutomations(): Promise<EmailTemplate[]> {
    const url = '/?reference=false&isTemplatesList=false';
    const response = await this.get(url);
    return response.data;
  }
}

export default new EmailTemplatesAPI();
